// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2YiZ9","row":"ProcedureTreatmentSummary_row__3-CwQ"};